__turbopack_export_value__({
  "filters": "Doctors-module-scss-module___GJona__filters",
  "filtersWrapper": "Doctors-module-scss-module___GJona__filtersWrapper",
  "filters__dropdown": "Doctors-module-scss-module___GJona__filters__dropdown",
});
